import React, { ComponentType } from 'react'
import { NoMeetingResult } from './NoMeetingResult'
import { ListMeetingResult } from './ListMeetingResult'
import { MapMeetingResult } from './MapMeetingResult'
import { TextMeetingResult, TextMeetingResultProps } from './TextMeetingResult'
import { AiFeature } from '../../../../../../../models/AiFeature'
import { AiResult } from '../../../../../../../models/AiResult'
import { getSafeValueOnPath } from '../../../utils'
import { BooleanMeetingResult } from './BooleanMeetingResult'

interface StructuredSummaryMeetingResultViewProps {
  aiFeature: AiFeature
  aiResult: AiResult
  basePath?: string
  path?: string
  onFormattedResultChange: (basePath: string, path: string, contentType: string, content: string) => void
  className?: string
  displayAsList?: boolean
  parentHasMapValue?: boolean
  CustomTextMeetingResult?: ComponentType<TextMeetingResultProps>
}

export const StructuredSummaryMeetingResultView: React.FC<StructuredSummaryMeetingResultViewProps> = ({
  aiFeature,
  aiResult,
  basePath = '$',
  path = '$.result',
  onFormattedResultChange,
  className = '',
  displayAsList = false,
  parentHasMapValue = false,
  CustomTextMeetingResult,
}) => {
  const result = getSafeValueOnPath(getSafeValueOnPath(aiResult.result, basePath), path)

  if (typeof result === 'boolean') {
    return <BooleanMeetingResult result={result} />
  }
  if (!result) {
    return <NoMeetingResult />
  }

  if (Array.isArray(result)) {
    return (
      <ListMeetingResult
        aiResult={aiResult}
        className={className}
        aiFeature={aiFeature}
        onFormattedResultChange={onFormattedResultChange}
        basePath={basePath}
        path={path}
        parentHasMapValue={parentHasMapValue}
      />
    )
  }

  if (typeof result === 'object') {
    return (
      <MapMeetingResult
        aiResult={aiResult}
        aiFeature={aiFeature}
        onFormattedResultChange={onFormattedResultChange}
        basePath={basePath}
        path={path}
        parentHasMapValue={parentHasMapValue}
      />
    )
  }

  const TextMeetingResultElement = CustomTextMeetingResult ?? TextMeetingResult

  return (
    <TextMeetingResultElement
      aiFeature={aiFeature}
      aiResult={aiResult}
      basePath={basePath}
      path={path}
      className={className}
      onFormattedResultChange={onFormattedResultChange}
      displayAsList={displayAsList}
    />
  )
}
